var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16Z",
    fill: "white",
    stroke: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5749 18.6434C10.5204 18.6983 10.4828 18.7677 10.4669 18.8434L9.90994 21.6294C9.89854 21.6866 9.89999 21.7457 9.91417 21.8022C9.92834 21.8588 9.9549 21.9115 9.99192 21.9566C10.0289 22.0016 10.0755 22.0379 10.1283 22.0628C10.181 22.0877 10.2386 22.1005 10.2969 22.1004C10.3228 22.1004 10.3486 22.0978 10.3739 22.0924L13.1589 21.5354C13.2348 21.52 13.3044 21.4824 13.3589 21.4274L19.5929 15.1935L16.8079 12.4084L10.5749 18.6434Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5205 10.4784C21.151 10.1095 20.6501 9.90234 20.128 9.90234C19.6058 9.90234 19.105 10.1095 18.7355 10.4784L17.6455 11.5684L20.4305 14.3534L21.5205 13.2624C21.8896 12.893 22.097 12.3922 22.097 11.8699C22.097 11.3477 21.8896 10.8468 21.5205 10.4774V10.4784Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.85fd446682265cc87ecff683e17bea7d.svg";
export { ForwardRef as ReactComponent };